<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button></span>
        <div slot="content">
            <div class="content-name">
                <div class="btn-wrap btn-type1 clearfix">
                    <button type="submit" class="btn-size btn-blue fl_right" v-show="form.showSave" @click="savePayChange">
                        <span class="btn-icon">
                        <i class="fas fa-save"></i>
                        </span>
                        <!-- {{$t('save')}} -->
                        {{ this.$i18n.messages[this.$store.state.locale].save }}
                    </button>
                    
                </div>
            </div>
            <div class="grid-wrap">
                <div class="table-area">
                    <div class="table-b">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="rowData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReady"
                            @cell-clicked="onCellClicked"
                            @cell-value-changed="onCellValueChange"
                            @first-data-rendered="onFirstDataRendered"/>
                    </div>
                </div>

            </div>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
 import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * lodash
 */
 import _ from 'lodash';
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import RadioCellRenderer from './changePayRadio';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';

export default {
    components: {Layout, AgGridVue},
    props: {
        data: {
            Type: Object,
            default: {
                asId: '',
                asStatus: '',
                payYnList: [],
                processList: []
            }
        }
    },
    data() {
        return {
            // AG-GRID OPTION [START]
            gridStyle : 'width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                'select': SelectCellRenderer,
                'input': InputCellRender,
                'datePicker': DatepickerCellRenderer,
                'checkbox': CheckboxCellRenderer,
                'radio': RadioCellRenderer,
            },
            //AG-GRID OPTION [END]
            title: '유무상변경',
            rowData: [],
            form : {
                asId: '',
                asStatus: '',
                payYnList: [],
                processList: [],
                showSave: false
            },
            changePayOptions: []
        }
    },
    mounted() {
        console.log('mounted this.data : ', this.data);
        this.form.asId = this.data.asId;
        this.form.asStatus = this.data.asStatus;
        this.form.payYnList = this.data.payYnList;
        this.form.processList = this.data.processList;

        // 접수관리 : 6
        const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===6);
console.log('auth: ', auth );

        let GrantUpdate = false; // 수정권한
        if(auth && auth.length > 0){
            GrantUpdate = auth[0].grantUpdate === 'Y' ? true : false;   
        }

        if(GrantUpdate && this.form.asStatus === 'Complete'){
            this.form.showSave = true;
        }

    },
    methods: {
        onFirstDataRendered(params) {
            const initIdx = 0;
            params.api.forEachNode((node) => {
                //node.setSelected(node.rowIndex === initIdx);
                if(node.rowIndex === initIdx) {
                    node.setSelected(true);
                }
            });
        },
        onReady(params) {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
            this.createColumnDefs();

            //set data
            const updateData = (data) => params.api.setRowData(data);
            this.rowData = this.form.processList.map((x,index)=>{
                const vPayYnObj = this.form.payYnList.filter(y=>y.key === x.payYn)
                const vPayYnNm = vPayYnObj && vPayYnObj.length>0 ? vPayYnObj[0].value : ''
                const xObj ={
                    no: index+1,
                    makerNm: x.makerNm,
                    modelGroupNm: x.modelGroupNm,
                    modelNm: x.modelNm,
                    serialNo: x.serialNo,
                    purchaseDt: x.purchaseDt,
                    changePayYnCd: x.changePayYnCd,
                    //처리 내용 사유에 대한 키값을 받게 된다면 값 세팅해주세요.
                    changePayRSKey: `${index+1}`.padStart(3, 'N0'),
                    changePayYnMemo: x.changePayYnMemo,
                    payYn: x.payYn,
                    payYnNm: vPayYnNm
                }
                console.log('update read order', xObj)
                return xObj
            }) ;
             // [{model: 'L2200DMW-5GSTK', recptTp: '01', yn: 'N', prodNo: '903LMB700061'}, {model: 'L2200DMW-5GSTK+', recptTp: '02', yn: 'Y', prodNo: '907LMB160120', prchsDt: '20221211'}];
            updateData(this.rowData);

        },
        createColumnDefs() {
            let vm = this;
            this.columnDefs = [
                {
                    headerName:'순번',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:150,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:150,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:180,
                    cellStyle:{textAlign: 'center'},
                    // cellRenderer: (params) => {
                    //     return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    // }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:120,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'구입년월일',
                    field:'purchaseDt', 
                    width:100,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'datePicker'
                },
                {
                    headerName:'접수',
                    field:'payYnNm', 
                    width:100,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'접수',
                    field:'payYn', 
                    hide: true,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'radio',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                    }  

                },
                //s. 처리내용에 대한 한 세트 컬럼
                {
                    headerName:'처리',
                    field:'changePayYnCd', 
                    width:320,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'radio',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: false
                        , isSelecBoxShow: true
                        , accessApi: true
                        , selectKey: 'N12'
                    }
                    // cellRenderer: 'select',
                    // cellRendererParams: {
                    //     options : [{key: '01', value: '유상'}, {key: '02', value: '무상'}],
                    //     detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                    //     detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    // }
                },
                {   //처리 유/무 에 따른 select box 키값 세팅
                    headerName:'처리사유',
                    field:'changePayRSKey',
                    hide: true, 
                    cellStyle:{textAlign: 'center'},
                },
                //e. 처리내용에 대한 한 세트 컬럼
                {
                    headerName:'변경사유',
                    field:'changePayYnMemo', 
                    width:210,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'input',
                    cellStyle:{textAlign:'left'},
                    cellRendererParams: {
                        obj: {
                            placeholder: "변경사유를 입력하세요."
                        }
                    }
                },
            ];
        },
        onCellValueChange(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;
            console.log('onCellValueChange params.data ', params.data.changePayYnCd)
            
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;
            console.log('onCellClicked params.data ', params.data.changePayYnCd)
            
            // this.data = this.data.map((x, i) => {
            //     if(idx === i) {
            //         if(x.chk === 'Y') {
            //             return x;
            //         } else {
            //             x.chk = x?.chk !== 'Y' ? 'Y' : 'N';
            //         }
            //     } else {
            //         if(x.chk === 'Y') {
            //             x.chk = x?.chk !== 'N' ? 'N' : 'Y';
            //         } else {
            //             return x;
            //         }
            //     }
            //     return x;
            // });

            // const {model, prodNo} = this.data.filter(x => x.chk === 'Y')?.[0];
            
            // this.form = _.merge(this.form, {model, prodNo});
        },
        getCombo(){
            // 유/무상 처리
            // this.$http.get(`/api/codeMng/combo`, {params: {parentId: 353}}) // ChangePayYn
            //     .then(response => {
            //         this.payYnList = response.data || []
            //         console.log('payYnList data :', response.data )
            //     });
        },
        savePayChange(){
            // 저장처리
            let vNo = ''
            console.log('savePayChange start', this.rowData)
            this.rowData.filter(x=>x.changePayYnCd.trim() ==='' || x.changePayRSKey === '' ).map((y, index)=>{
                console.log('savePayChange filter: ', y)
                if(index === 0){
                    vNo = y.no
                } else {
                    vNo = vNo + ', ' + y.no
                }
                return y
            })
            if(vNo !==''){
                this.$swal({
                    type: 'warning',
                    text: vNo + '번 제품의 유무상변경사유를 선택해 주십시오.'});
                return false;
            }

            vNo = ''
            this.rowData.filter(x=>x.changePayYnMemo.trim() ==='').map((y, index)=>{
                if(index === 0){
                    vNo = y.no
                } else {
                    vNo = vNo + ', ' + y.no
                }
                return y
            })
            if(vNo !==''){
                this.$swal({
                    type: 'warning',
                    text: vNo + '번 제품의 유무상변경사유를 입력해주십시오.'});
                return false;
            }
            
            let vAsProcessData = JSON.parse(JSON.stringify(this.form.processList)) || [] 
            vAsProcessData.map((x, index)=>{
                x.changePayYnCd = this.rowData[index].changePayYnCd
                x.changePayYnMemo = this.rowData[index].changePayYnMemo
            })

            const vSaveform = {
                asId: this.form.asId,
                asProcessData : vAsProcessData
            }
            console.log('vSaveform : ', vSaveform)
            this.$swal({
                    type: 'warning',
                    text: '유무상변경사유를 변경하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        let vResultOK = 'OK'
                        this.$store.commit('loading')
                        this.$http.put("/api/asMng/call/updateProcReAmt", vSaveform)
                            .then(response => {
                                this.$swal({ type: 'success', text: '유무상변경사유가 변경되었습니다.' });
                                
                            }).catch((e) => {
                                vResultOK = 'FAIL'
                                console.error(e);
                                this.$swal({ type: 'success', text: '유무상변경사유의 변경에 실패했습니다.' })
                            })
                            .finally(() => {
                                this.$store.commit('finish')

                                this.$emit('close', vResultOK)
                                this.$parent.close()
                            });
                    }
                });
        }
    }
}
</script>